import axios from 'axios';

const hightouchApiKey = 'c127167b-b318-41f1-9df4-6caebc6f400c';

// Create a clean axios instance without interceptors
const syncAxios = axios.create();

export const triggerHightouchSync = async (syncId: string): Promise<any> => {
    const response = await syncAxios.post(
        `https://micro-api-proxy-z8wfa.ondigitalocean.app/hightouch/syncs/${syncId}/trigger`,
        {
            headers: {
                'Authorization': `Bearer ${hightouchApiKey}`,
                'Content-Type': 'application/json',
            },
        }
    );
    return response.data;
};

export const triggerApplicationSync = async (
    applicationId: string,
    step: number = 0
): Promise<any> => {
    try {
        const response = await syncAxios.post(
            `https://api.sync.golendica.com/hs/application/${applicationId}?step=${step}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Skip-Global-Error': 'true',
                },
            }
        );
        return response.data;
    } catch (error) {
        // Silently fail and return null
        return null;
    }
};
